import {IApplication} from "../../application/types/IApplication";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IAppDispatch} from "../../store/store";
import {patchUserConsent} from "../api/patch_user_consent";
import {patchUserProfileApi} from "../api/patch_user_profile";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";
import {MarketingConsentType} from "../types/MarketingConsentType";

export const patchUserProfileFromApplication =
    (userProfileData: IUserProfile, {name, marketing_email, marketing_sms, phone}: IApplication) =>
    async (dispatch: IAppDispatch) => {
        const userProfileDataToUpdate: IPatchUserProfilePayload = {};

        if (marketing_email || marketing_sms) {
            await patchUserConsent({[MarketingConsentType.PHONE]: marketing_sms, [MarketingConsentType.EMAIL]: marketing_email});
        }

        if (!userProfileData.name && name) {
            userProfileDataToUpdate.name = name;
        }

        if (!userProfileData.phone && phone) {
            userProfileDataToUpdate.phone = phone;
        }

        if (!!Object.keys(userProfileDataToUpdate).length) {
            try {
                await dispatch(patchUserProfileApi.endpoints.patchUserProfile.initiate(userProfileDataToUpdate)).unwrap();
            } catch (error) {
                notifyBugsnag(error, "patchUserProfileFromApplication");
            }
        }
    };
import {IApplication} from "../../application/types/IApplication";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {IAppDispatch} from "../../store/store";
import {patchUserConsent} from "../api/patch_user_consent";
import {patchUserProfileApi} from "../api/patch_user_profile";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";
import {MarketingConsentType} from "../types/MarketingConsentType";

export const patchUserProfileFromApplication =
    (userProfileData: IUserProfile, {name, marketing_email, marketing_sms, phone}: IApplication) =>
    async (dispatch: IAppDispatch) => {
        const userProfileDataToUpdate: IPatchUserProfilePayload = {};

        if (marketing_email || marketing_sms) {
            await patchUserConsent({[MarketingConsentType.PHONE]: marketing_sms, [MarketingConsentType.EMAIL]: marketing_email});
        }

        if (!userProfileData.name && name) {
            userProfileDataToUpdate.name = name;
        }

        if (!userProfileData.phone && phone) {
            userProfileDataToUpdate.phone = phone;
        }

        if (!!Object.keys(userProfileDataToUpdate).length) {
            try {
                await dispatch(patchUserProfileApi.endpoints.patchUserProfile.initiate(userProfileDataToUpdate)).unwrap();
            } catch (error) {
                notifyBugsnag(error, "patchUserProfileFromApplication");
            }
        }
    };
